import { z } from 'zod';
/**
 * Payloads of the `families` Edge Function.
 *
 * Kept apart from `./family.ts` and free of any relative import: the function
 * loads this file, and neither Deno nor the Supabase CLI — which mounts every
 * file a function imports when the stack starts — resolves the `.js`
 * specifiers TypeScript requires.
 */
/** Name an admin gives a member who has no account (a child, a grandparent). */
export const MemberDisplayNameSchema = z.string().trim().min(1).max(60);
/** Payload adding a member without an account. */
export const AddFamilyMemberSchema = z.object({
    display_name: MemberDisplayNameSchema,
});
/** Payload renaming a member without an account. */
export const RenameFamilyMemberSchema = AddFamilyMemberSchema;
/**
 * Payload inviting someone by email: a newcomer, or — with `member_id` — the
 * person behind a member who has no account yet.
 */
export const InviteMemberSchema = z.object({
    email: z.string().trim().email(),
    member_id: z.string().uuid().optional(),
});
/** Payload changing a member's role. */
export const UpdateMemberRoleSchema = z.object({
    role: z.enum(['admin', 'member']),
});
//# sourceMappingURL=family-requests.js.map